module.exports = __webpack_public_path__ + "img/arrow_down_3.189076ee.svg";